import { render } from "./resignation-list.vue?vue&type=template&id=7f800938"
import script from "./resignation-list.vue?vue&type=script&lang=js"
export * from "./resignation-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__